<template>
  <transition name="modal">
    <div v-if="isVisible" class="modal-mask" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-content">
          <!-- 标题 -->
          <div class="modal-row title-row">
            <h2>网易邮箱</h2>
          </div>
          
          <!-- 二维码图片 -->
          <div class="modal-row qr-code-row">
            18293690292@163.com
          </div>
        
          
          <!-- 操作按钮 -->
          <div class="modal-row button-row">
            <button class="btn-close" @click="closeModal">关闭</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Email',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeModal() {
      this.isVisible = !this.isVisible
      this.$emit('update:visible', false);
    },
    downloadQRCode() {
      // 创建虚拟链接下载二维码
      const link = document.createElement('a');
      link.href = this.qrCodeImage;
      link.download = '微信公众号二维码.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // 可以添加下载成功的提示
      this.$message.success('二维码已保存');
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;
}

.modal-container {
  width: 400px;
  max-width: 90%;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  padding: 25px;
  margin: 10px;
  text-align: center;
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-row {
  margin-bottom: 20px;
  width: 100%;
}

.title-row h2 {
  color: #333;
  margin: 0;
  font-size: 22px;
}

.qr-code-row {
  padding: 10px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
}

.qr-code-image {
  width: 200px;
  height: 200px;
  object-fit: contain;
}

.tip-row {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

.button-row {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 10px;
}

.button-row button {
  padding: 8px 20px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.btn-close {
  background-color: #f5f5f5;
  color: #666;
}

.btn-close:hover {
  background-color: #e0e0e0;
}

.btn-download {
  background-color: #07C160;
  color: white;
}

.btn-download:hover {
  background-color: #06AD56;
}

/* 过渡动画 */
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  transform: scale(0.9);
}
</style>